import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from "vuex";
import { mapFields } from "@joandvgv/vuex-map-fields";
import HTMLTextEvaluationMixin from "@Shared/utils/application-mixins/html-text-evaluation-mixin";
import HtmlIframePreview from "@Shared/components/general/html-iframe-preview.vue";
import ProfileAvatar from "@Shared/components/general/profile-avatar";
import DatepickerInput from "@Shared/components/inputs/datepicker-input.vue";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import InlinePrompt from "@Shared/components/general/inline-prompt";
import RichTextEditor from "@Shared/utils/rich-text-editor";
import TimeInput from "@Broker/@Modules/automation/automation/components/argument-types/time";
import TimelineCardFooter from "@Broker/@Modules/clients/board/client-profile/components/timeline/utils/timeline-card-footer.vue";
import Err from "@Broker/@Routes/error";
import moment from "moment";
import { debounce } from "lodash";
import { showToast } from "@Shared/utils/constants";
import { DELETE_REFERRER_FOLLOW_UP, EDIT_REFERRER_FOLLOW_UP } from "@Broker/@Modules/clients/referrers/store/referrer-actions.ts";
import { REFERRER_CUSTOM_FIELDS_TAGS, REFERRER_CUSTOM_FIELDS_HINT_TAGS } from "@Broker/@Modules/clients/referrers/store/referrer-getters.ts";
import { v4 as uuidv4 } from "uuid";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ReferrerTimelineFollowUp",
  components: {
    ProfileAvatar,
    DatepickerInput,
    MaterialInput,
    TimeInput,
    InlinePrompt,
    TimelineCardFooter,
    HtmlIframePreview
  },
  mixins: [HTMLTextEvaluationMixin],
  props: {
    creator: {
      type: Object,
      default: () => ({})
    },
    scheduledDate: {
      type: [String, Date],
      required: true
    },
    scheduledTime: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    pinned: {
      type: Boolean,
      default: false
    },
    complete: {
      type: Boolean,
      default: false
    },
    description: {
      type: String,
      default: ""
    },
    activityType: {
      type: String,
      default: ""
    },
    referrerId: {
      type: [String, Number],
      default: ""
    },
    createdAt: {
      type: String,
      required: true
    },
    updatedAt: {
      type: String,
      required: true
    },
    isPinned: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editing: false,
      height: "auto",
      isComplete: this.complete,
      followUpDescription: RichTextEditor.sanitizeRichTextWithoutEmbeddedMedia(this.description),
      followUpScheduledDate: this.scheduledDate,
      followUpScheduledTime: this.scheduledTime,
      labelValue: uuidv4()
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapFields("AccountStore", ["accountPreferences.followUpNotificationTime"])), mapGetters("ReferrerStore", [REFERRER_CUSTOM_FIELDS_TAGS, REFERRER_CUSTOM_FIELDS_HINT_TAGS])), {}, {
    canSave() {
      return this.htmlToTextContent(this.followUpDescription) !== "";
    },
    notUpdatedYet() {
      return this.createdAt === this.updatedAt;
    },
    name() {
      const {
        givenName,
        familyName
      } = this.creator;
      return this.$options.filters.nameFormat(givenName, familyName);
    },
    scheduledCssClass() {
      if (this.complete) return "text-gray mid-opacity";
      return this.$options.filters.parseReminderClassificationClass(this.scheduledDate, this.scheduledTime);
    },
    formattedScheduledTime() {
      return moment(this.followUpScheduledTime, "'HH:mm'").format("LT");
    },
    descriptionText: {
      get() {
        return this.followUpDescription;
      },
      set(value) {
        this.followUpDescription = this.upperCaseFirst(value);
      }
    },
    sanitizedDescriptionText() {
      return RichTextEditor.sanitizeRichTextWithoutEmbeddedMedia(this.description);
    },
    customFieldsTags() {
      return this.REFERRER_CUSTOM_FIELDS_TAGS(this.referrerId);
    },
    customFieldsHintsTags() {
      return this.REFERRER_CUSTOM_FIELDS_HINT_TAGS(this.referrerId);
    }
  }),
  watch: {
    editing(val) {
      this.$nextTick(() => {
        if (val) this.init();
        $(".note-codable").attr("id", `textarea-description-${this.labelValue}`);
        $("#foreColorPicker").attr("id", `foreColorPicker-${this.labelValue}`);
        $("#backColorPicker").attr("id", `backColorPicker-${this.labelValue}`);
      });
    },
    description(val) {
      this.followUpDescription = RichTextEditor.sanitizeRichTextWithoutEmbeddedMedia(this.upperCaseFirst(val));
    },
    complete(val) {
      this.isComplete = val;
    },
    customFieldsTags: {
      deep: true,
      handler(value) {
        var _this$editor;
        (_this$editor = this.editor) == null ? void 0 : _this$editor.updateOptions({
          mergeTags: defaults => {
            return [...defaults, ...value];
          }
        });
      }
    },
    customFieldsHintsTags: {
      deep: true,
      handler(value) {
        var _this$editor2;
        (_this$editor2 = this.editor) == null ? void 0 : _this$editor2.updateOptions({
          hints: defaults => {
            return [...defaults, ...value];
          }
        });
      }
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ReferrerStore", [DELETE_REFERRER_FOLLOW_UP, EDIT_REFERRER_FOLLOW_UP])), {}, {
    init() {
      const target = $(this.$refs.textarea);
      this.editor = new RichTextEditor(target, {
        airMode: true,
        height: "6vw",
        substitutionHints: true,
        showMergeTags: true,
        loadPreferences: false,
        blockPastedImages: false,
        sanitizeContent: RichTextEditor.sanitizeRichTextWithoutEmbeddedMedia,
        mergeTags: defaults => {
          return [...defaults, ...this.customFieldsTags];
        },
        hints: defaults => {
          return [...defaults, ...this.customFieldsHintsTags];
        },
        callbacks: {
          onChange: this.handleEditorChange
        }
      });
    },
    handleEditorChange(_, content) {
      this.descriptionText = content;
    },
    upperCaseFirst(text) {
      return this.$options.filters.upperCaseFirst(text);
    },
    handleInput({
      target: note
    }) {
      note.style.height = "auto";
      note.style.height = note.scrollHeight + "px";
    },
    handleSubmit() {
      this.editing = false;
      this.saveFollowUp();
    },
    async handleDelete() {
      try {
        await this.DELETE_REFERRER_FOLLOW_UP({
          referrerId: this.referrerId,
          followUpId: this.id
        });
        showToast("success", "referrerActivityDeleted");
      } catch (error) {
        Err.handle(error);
      }
    },
    handlePin(id, type, pinned) {
      this.$emit("pin", id, type, pinned);
    },
    async saveFollowUp() {
      if (this.editor) {
        this.followUpDescription = this.editor.getHTML();
      }
      try {
        await this.EDIT_REFERRER_FOLLOW_UP({
          referrerId: this.referrerId,
          followUpId: this.id,
          data: {
            description: this.followUpDescription,
            scheduledDate: this.followUpScheduledDate,
            scheduledTime: this.followUpScheduledTime,
            complete: this.isComplete,
            updatedAt: moment().utc().format()
          }
        });
        showToast("success", "referrerActivityUpdated");
      } catch (error) {
        this.isComplete = this.complete;
        this.followUpDescription = this.description;
        this.followUpScheduledDate = this.scheduledDate;
        this.followUpScheduledTime = this.scheduledTime;
        Err.handle(error);
      }
    },
    editFollowUp() {
      this.editing = true;
      this.$nextTick(() => {
        this.$refs.textarea.focus();
      });
    },
    completeFollowUp: debounce(function () {
      this.isComplete = !this.isComplete;
      this.saveFollowUp();
    }, 200),
    editScheduledDate() {
      this.editing = true;
    }
  })
});